import { Badge } from "@theg1group/ui";
import { partnerStatusLabel, statusTone } from "../lib/format.ts";
import type { PartnerStatus } from "../lib/types.ts";

export function PartnerStatusBadge({ status }: { status: PartnerStatus | string }) {
	return <Badge variant={statusTone(status)}>{partnerStatusLabel(status)}</Badge>;
}
